module.exports = __webpack_public_path__ + "static/media/quem_somos.905b2376.png";